import { render, staticRenderFns } from "./FormBuilderItems.vue?vue&type=template&id=241fb8c5&scoped=true"
import script from "./FormBuilderItems.vue?vue&type=script&lang=js"
export * from "./FormBuilderItems.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderItems.vue?vue&type=style&index=0&id=241fb8c5&prod&lang=css"
import style1 from "./FormBuilderItems.vue?vue&type=style&index=1&id=241fb8c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241fb8c5",
  null
  
)

export default component.exports